export const useAvatar = ({
  firstName,
  lastName
}: {
  firstName: string | undefined;
  lastName: string | undefined;
}): { avatar: string } => {
  //TODO read from avatar property once avatar is stiched into me query
  // which will return actual image or image with first name last name
  const firstNameInitial = firstName?.trim()[0];
  const lastNameInitial = lastName?.trim()[0];

  return {
    avatar:
      firstNameInitial && lastNameInitial
        ? `${firstNameInitial}${lastNameInitial}`
        : ''
  };
};
